<script setup>
import { useToggle } from '@vueuse/core';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const [isOpen, toggle] = useToggle(props.defaultOpen);
</script>

<template>
  <button
    v-bind="$attrs"
    type="button"
    :aria-expanded="isOpen"
    class="group flex items-center justify-between gap-2 w-full cursor-pointer pb-2 pt-4 border-t border-n-weak ltr:text-left rtl:text-right"
    @click="toggle()"
  >
    <span class="text-heading-2 text-n-slate-12">
      {{ title }}
    </span>
    <Icon
      icon="i-lucide-chevron-down"
      class="flex-shrink-0 size-4 text-n-slate-11 transition-transform duration-200 group-hover:text-n-slate-12"
      :class="{ 'rotate-180': isOpen }"
    />
  </button>
  <div v-if="isOpen" class="w-full space-y-4 pt-4 mb-4">
    <slot />
  </div>
</template>
